export default "__VITE_ASSET__d3328188__"